export default __webpack_public_path__ + "static/media/image.seven-s-idea-pvt-ltd.16520cf6.png";